import React from 'react'
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom'
import './App.css'
import Home from './Components/Home/Home'
import Header from './Components/Header/Header'
import AddQuestion from './Components/AddQuestion/AddQuestion'
import AddTopic from './Components/AddTopic/AddTopic'
import ReportedQuestions from './Components/ReportedQuestions/ReportedQuestions'
import TopicQuestions from './Components/TopicQuestions/TopicQuestions'
import Login from './Components/Login/Login'
import isAuthenticated from './Auth/AuthenticateUser'
import DeletedTopics from './Components/DeletedTopics/DeletedTopics'
import RecentActivity from './Components/RecentActivity/RecentActivity'
import EditQuestion from './Components/EditQuestion/EditQuestion'
import AddOnboarding from './Components/AddOnboarding/AddOnboarding'
import ViewOnboarding from './Components/ViewOnboarding/ViewOnboarding'
import EditOnboarding from './Components/EditOnboarding/EditOnboarding'
import EditTopic from './Components/EditTopic/EditTopic'
import AddExam from './Components/AddExam/AddExam'
import ViewExams from './Components/ViewExams/ViewExams'
import EditExam from './Components/EditExam/EditExam'
import EditUser from './Components/EditUser/EditUser'
import Users from './Components/JoinedUsers/JoinedUsers'
import ViewTopics from './Components/ViewTopics/ViewTopics'
import ImageUpload from './Components/ImageUpload/ImageUpload'
import AddQuestionV2 from './Components/AddQuestionV2/AddQuestionV2'
import RecentActivityV2 from './Components/RecentActivityV2/RecentActivityV2'
import AddQuestionV3 from './Components/AddQuestionV3/AddQuestionV3'
import EditQuestionV3 from './Components/EditQuestionV3/EditQuestionV3'
import EditQuestionV2 from './Components/EditQuestionV2/EditQuestionV2'

function App() {
    const PrivateWrapper = () => {
        return isAuthenticated() ? <Outlet /> : <Navigate to='/login' />
    }
    return (
        <BrowserRouter>
            <div>
                <Header />
                <Routes>
                    <Route exact path='/login' element={<Login />} />
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/' element={<Home />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/add-question' element={<AddQuestion />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/add-question-v2' element={<AddQuestionV2 />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/add-question-v3' element={<AddQuestionV3 />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/add-topic' element={<AddTopic />} />
                    </Route>'
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/topics' element={<ViewTopics />} />
                    </Route>'
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/users' element={<Users />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/topic-questions/:id' element={<TopicQuestions />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/reported-questions' element={<ReportedQuestions />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/deleted-topics' element={<DeletedTopics />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/recent-activity' element={<RecentActivity />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/recent-activity-v2' element={<RecentActivityV2 />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/edit-question' element={<EditQuestion />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/edit-question-v2' element={<EditQuestionV2 />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/edit-question-v3' element={<EditQuestionV3 />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/add-onboarding' element={<AddOnboarding />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/view-onboarding' element={<ViewOnboarding />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/onboarding' element={<EditOnboarding />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/edit-topic' element={<EditTopic />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/add-exam' element={<AddExam />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/view-exams' element={<ViewExams />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/exam' element={<EditExam />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/edit-user' element={<EditUser />} />
                    </Route>
                    <Route element={<PrivateWrapper />}>
                        <Route exact path='/image-upload' element={<ImageUpload />} />
                    </Route>
                </Routes>
            </div>
        </BrowserRouter>
    )
}

export default App
